import { motion } from "framer-motion";
import {
  Mail,
  Linkedin,
} from "lucide-react";

const Team = () => {
  const teamMembers = [
    {
      name: "Abhisek Tiwari",
      role: "Co-founder",
      email: "abhisek@clinicalaiassistance.com",
      linkedin: "https://www.linkedin.com/in/abhisektiwari/",
      image:
        "../img/Abhisek.png",
    },
    {
      name: "David Schramm",
      role: "Co-founder",
      email: "david@clinicalaiassistance.com",
      linkedin: "https://www.linkedin.com/in/davidcschramm/",
      image:
        "../img/David.png",
    },
  ];

  return (
    <section className="bg-white dark:bg-black py-20 px-4 sm:px-6 lg:px-10">
      {/* Heading */}
      <div className="text-center max-w-3xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-5xl font-bold text-black dark:text-white"
        >
          Meet Our Team
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-4 text-gray-600 dark:text-gray-400 text-lg"
        >
          The people behind Clinical AI Assistance driving innovation
          in healthcare AI solutions.
        </motion.p>
      </div>

      {/* Team Cards */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
        {teamMembers.map((member, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            whileHover={{ y: -8 }}
            className="bg-gray-50 dark:bg-[#111] rounded-3xl overflow-hidden shadow-lg border border-gray-200 dark:border-gray-800"
          >
            {/* Image */}
            <div className="h-[420px] overflow-hidden bg-gray-100 dark:bg-[#1a1a1a]">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover hover:scale-105 transition duration-500"
              />
            </div>

            {/* Content */}
            <div className="p-8">
              <h3 className="text-2xl font-bold text-black dark:text-white">
                {member.name}
              </h3>

              <p className="mt-2 text-[#106EE8] font-medium">
                {member.role}
              </p>

              {/* Email */}
              <a
                href={`mailto:${member.email}`}
                className="mt-6 flex items-center gap-3 text-gray-700 dark:text-gray-300 hover:text-[#106EE8] transition"
              >
                <Mail size={18} />
                <span>{member.email}</span>
              </a>

              {/* LinkedIn */}
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 flex items-center gap-3 text-gray-700 dark:text-gray-300 hover:text-[#106EE8] transition"
              >
                <Linkedin size={18} />
                <span>LinkedIn Profile</span>
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Team;